





































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "@/models/Application";
import { Restaurant } from "@/viewmodels/Restaurant";

@Component({})
export default class extends Vue {
  public collection = app.restaurantCollection;
  public search: string = "";
  public model: Restaurant = new Restaurant({}, this.collection);
  public selectedModel: Restaurant | null = null;

  public dialog = false;
  public formTitle: string = "Restaurant";

  public showPassword = false;

  public headers = [
    { text: "Restaurant", value: "name" },
    { text: "Address", value: "address" },
    { text: "City", value: "city" },
    { text: "Province", value: "province" },
    { text: "Zip Code", value: "zip_code" },
    { text: "Phone", value: "phone" },
    { text: "First Name", value: "first_name" },
    { text: "Last Name", value: "last_name" },
    { text: "Email", value: "email" },
    { text: "Actions", value: "" }
  ];

  public mounted() {
    this.search = this.collection.search;
    this.collection.refreshData();
  }

  @Watch("search")
  public onSearchChange() {
    this.collection.doSearch(this.search);
  }

  public remove(model: any) {
    const dialog: any = (this.$root as any).$confirm;

    dialog("Delete", "Are you sure?").then((confirm: boolean) => {
      if (confirm) {
        model.delete();
      }
    });
  }

  public close() {
    this.dialog = false;
  }

  public async save() {
    try {
      await this.model.save();
      this.dialog = false;
      this.$store.dispatch("showSnackbar", { message: "Saved succesfully!" });
    } catch (e) {
      this.$store.dispatch("showSnackbar", {
        message: "Whoops, error while saving data!"
      });
    }
  }

  public add() {
    this.model = new Restaurant({}, this.collection);
    this.dialog = true;
  }

  public edit(item: Restaurant) {
    this.model = item;
    this.dialog = true;
  }
}
